export const LANG_CHANGED_EVENT = "langChanged";
export const CLEANUP_PARTS_MS = 1000 * 60;
//# sourceMappingURL=model.js.map